import PolicyLayout, { PolicySection } from "@/components/PolicyLayout";

const LAST_UPDATED = "May 15, 2026";

export default function PrivacyPage() {
  return (
    <PolicyLayout
      title="Privacy Policy"
      subtitle="Your Data"
      lastUpdated={LAST_UPDATED}
      testId="privacy-page"
    >
      <p>
        Resurrected Gun Parts ("we," "us," or "our") respects your privacy. This Privacy Policy explains how we
        collect, use, share, and protect information about you when you visit{" "}
        <a href="https://resurrectedgunparts.com" className="text-[#C0A062] hover:underline">resurrectedgunparts.com</a>{" "}
        (the "Site") or make a purchase from us.
      </p>

      <PolicySection title="1. Information We Collect">
        <p>We collect information in the following ways:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong className="text-white">Information you provide:</strong> Your name, email address, billing and
            shipping address, phone number, and order details when you create an account or place an order.
          </li>
          <li>
            <strong className="text-white">Payment information:</strong> Payment card data is processed by our PCI-DSS
            compliant third-party payment processors. We do not store full credit card numbers on our servers.
          </li>
          <li>
            <strong className="text-white">Automatic data:</strong> IP address, browser type, device identifiers,
            referring URL, pages visited, and timestamps via cookies and similar technologies.
          </li>
          <li>
            <strong className="text-white">Communications:</strong> Messages you send to us, including contact form
            submissions, live chat transcripts, and email correspondence.
          </li>
        </ul>
      </PolicySection>

      <PolicySection title="2. How We Use Your Information">
        <p>We use your information to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Process orders, payments, and shipments and send transactional communications.</li>
          <li>Provide customer service and respond to inquiries.</li>
          <li>Operate, maintain, and improve the Site and our products.</li>
          <li>Send you marketing or back-in-stock notifications (only if you opt in — you can unsubscribe anytime).</li>
          <li>Prevent fraud, enforce our Terms, and comply with legal obligations.</li>
        </ul>
      </PolicySection>

      <PolicySection title="3. How We Share Your Information">
        <p>We do not sell your personal information. We share information only with:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong className="text-white">Service providers</strong> who help us run the business (payment processors,
            shipping carriers, email delivery, hosting, and analytics), subject to confidentiality obligations.
          </li>
          <li>
            <strong className="text-white">Law enforcement or regulators</strong> when required by law, court order, or
            to protect our rights or the rights and safety of others.
          </li>
          <li>
            <strong className="text-white">Successors</strong> in the event of a merger, acquisition, or sale of
            assets.
          </li>
        </ul>
      </PolicySection>

      <PolicySection title="4. Cookies & Tracking">
        <p>
          We use cookies and similar technologies to keep you signed in, remember your cart, and analyze Site
          usage. You can disable cookies in your browser settings, but some Site features may not function properly.
        </p>
      </PolicySection>

      <PolicySection title="5. Data Retention">
        <p>
          We retain personal information for as long as needed to fulfill the purposes outlined in this Policy and to
          satisfy legal, accounting, or reporting requirements. You may request deletion of your account and associated
          data by contacting us (see Section 8).
        </p>
      </PolicySection>

      <PolicySection title="6. Security">
        <p>
          We use industry-standard administrative, technical, and physical safeguards (including HTTPS encryption,
          hashed passwords, and access controls) to protect your information. However, no method of transmission or
          storage is 100% secure, and we cannot guarantee absolute security.
        </p>
      </PolicySection>

      <PolicySection title="7. Your Rights">
        <p>
          Depending on your location, you may have rights to access, correct, delete, or restrict the use of your
          personal data, including under the California Consumer Privacy Act (CCPA) and the EU/UK General Data
          Protection Regulation (GDPR). To exercise these rights, contact us at the email below.
        </p>
        <p>
          <strong className="text-white">Do Not Track:</strong> Our Site does not currently respond to "Do Not Track"
          browser signals.
        </p>
        <p>
          <strong className="text-white">Children's Privacy:</strong> The Site is not directed to children under 18. We
          do not knowingly collect personal information from children.
        </p>
      </PolicySection>

      <PolicySection title="8. Contact Us">
        <p>
          If you have questions about this Privacy Policy or wish to exercise a data right:<br />
          Email:{" "}
          <a href="mailto:admin@resurrectedgunparts.com" className="text-[#C0A062] hover:underline">
            admin@resurrectedgunparts.com
          </a>
          <br />
          Phone: (928) 637-8133
        </p>
      </PolicySection>

      <PolicySection title="9. Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. Changes are effective when posted to this page.
          Material changes will be communicated by email or via a notice on the Site.
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
